import agent from "../../api/agent";
export const listOfUserProjects = (id) =>
  agent.requests.get(`Project/GetProjectByUserId?userId=${id}`);
  
  
  export const searchUsers = (pagerInputModel) =>
  agent.requests.post(`Customer/GetListSearch`,pagerInputModel);

  export const cacheClear = () => 
    agent.requests.get('/Status/redisCacheClear');